import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put, del } from "../../helpers/api_helper";
import slice from "./slice";
import * as URL from "../../helpers/url_helper";
import { toast } from "react-toastify";


export const getAgentTraits = createAsyncThunk(
  "getAgentTraits",
  async ({ callBack }, Thunk) => {
    try {
      const response = await get(URL.AGENT_TRAITS);
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const createAgent = createAsyncThunk(
  "createAgent",
  async ({ data, callBack }, Thunk) => {
    console.log(data, "dataCheck");
    try {
      const response = await post(URL.CREATE_AGENT, data);
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);


export const getAudioLibrary = createAsyncThunk(
  "getAudioLibrary",
  async ({ data, callBack }, Thunk) => {
    try {
      const response = await get(URL.GET_AUDIOS + data);
      callBack && callBack(null, response);
      return response;
    } catch (error) {
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);
